import { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SurveyPopup } from '@portal/common/components';
import { surveyService } from '@portal/common/services/api/survey';
import { SurveyResource } from '@portal/common/types';

import { getActiveSurvey } from '../../store/surveys/selectors';
import {
    dismissSurvey as dismissSurveyAction,
    postponeSurvey,
} from '../../store/user-settings/actions';
import {
    checkIsSurveyBannerVisible,
    getIsSurveyAccessible,
} from '../../store/user-settings/selectors';
import SurveyBanner from '../SurveyBanner';

const AppSurvey = memo(() => {
    const dispatch = useDispatch();

    const survey: SurveyResource = useSelector(getActiveSurvey);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const isSurveyAccessible = useSelector(getIsSurveyAccessible);
    const isBannerVisible = useSelector(checkIsSurveyBannerVisible);

    const showPopup = useCallback(() => setIsPopupVisible(true), []);
    const hidePopup = useCallback(() => setIsPopupVisible(false), []);

    const dismissSurvey = useCallback(async () => {
        dispatch(dismissSurveyAction(survey.id));
    }, [survey, dispatch]);

    const handlePostponeSurvey = useCallback(() => {
        dispatch(postponeSurvey(true));
    }, [dispatch]);

    const handleStartSurvey = useCallback(() => {
        dispatch(postponeSurvey(false));
    }, [dispatch]);

    useEffect(() => {
        if (isSurveyAccessible && !isBannerVisible) {
            showPopup();
        }
    }, [isBannerVisible, showPopup, isSurveyAccessible]);

    return (
        <>
            {isPopupVisible && (
                <SurveyPopup
                    survey={survey}
                    onSubmit={surveyService.submitSurveyResponse}
                    onPostpone={handlePostponeSurvey}
                    onHide={hidePopup}
                />
            )}
            {isBannerVisible && (
                <SurveyBanner onStart={handleStartSurvey} onClose={dismissSurvey} />
            )}
        </>
    );
});

export default AppSurvey;
